/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const deleteItemFieldValueRequestSchema = z.object({
  fieldValueIds: z.array(z.int()).nullish(),
});
